/**
 * Makes sure a value isn't undefined and isn't null.
 */
export const isDefined = (entity: any): boolean =>
  typeof entity !== 'undefined' && entity !== null;

export const isFunction = (fn: any): boolean => typeof fn === 'function';

/**
 * Gets a potential defined (controlled) value between arguments (controlled,
 * default, fallbacks, etc...).
 * This is useful in retrieving the preferred or initial state of something.
 *
 * For example, `defaultIsOpen` vs `isOpen`.
 */
export const getDefinedValue = (...args: any): any => {
  let result;
  for (const arg of args) {
    if (isDefined(arg)) {
      result = arg;
      break;
    }
  }

  return result;
};
